import { provider } from './UserSession.bs'

export default provider
